import { useState, FormEvent } from 'react';
import { Link } from 'react-router-dom';

export default function Footer() {
  const [email, setEmail] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState<'idle' | 'success' | 'error'>('idle');

  const handleNewsletterSubmit = async (e: FormEvent) => {
    e.preventDefault();
    setIsSubmitting(true);
    setSubmitStatus('idle');

    try {
      const formBody = new URLSearchParams();
      formBody.append('email', email);

      const response = await fetch('https://readdy.ai/api/form/d4rtar95bv6k73lc3atg', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: formBody.toString()
      });

      if (response.ok) {
        setSubmitStatus('success');
        setEmail('');
      } else {
        setSubmitStatus('error');
      }
    } catch (error) {
      setSubmitStatus('error');
    } finally {
      setIsSubmitting(false);
    }
  };

  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer className="bg-gradient-to-br from-emerald-900 to-emerald-800 text-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-12">
          <div>
            <div className="flex items-center gap-3 mb-6">
              <div className="w-12 h-12 flex items-center justify-center bg-emerald-600 rounded-full">
                <i className="ri-plant-line text-2xl text-white"></i>
              </div>
              <div>
                <div className="text-xl font-bold">Atlanta Stump Grinding Pros</div>
              </div>
            </div>
            <p className="text-sm text-emerald-100 leading-relaxed mb-4">
              Proudly serving Marietta, Smyrna, Buckhead, &amp; Vinings
            </p>
            <div className="flex items-center gap-2">
              <div className="w-8 h-8 flex items-center justify-center bg-emerald-700 rounded-full">
                <i className="ri-shield-check-line text-sm text-emerald-200"></i>
              </div>
              <span className="text-sm text-emerald-200 font-medium">Licensed & Insured</span>
            </div>
          </div>

          <div>
            <h4 className="text-base font-bold mb-6">Service Areas</h4>
            <ul className="space-y-3">
              <li>
                <a href="#contact" className="text-sm text-emerald-100 hover:text-white transition-colors cursor-pointer">
                  Marietta, GA
                </a>
              </li>
              <li>
                <a href="#contact" className="text-sm text-emerald-100 hover:text-white transition-colors cursor-pointer">
                  Smyrna, GA
                </a>
              </li>
              <li>
                <a href="#contact" className="text-sm text-emerald-100 hover:text-white transition-colors cursor-pointer">
                  Vinings, GA
                </a>
              </li>
              <li>
                <a href="#contact" className="text-sm text-emerald-100 hover:text-white transition-colors cursor-pointer">
                  Buckhead, GA
                </a>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-base font-bold mb-6">Resources</h4>
            <ul className="space-y-3">
              <li>
                <button onClick={() => scrollToSection('contact')} className="text-sm text-emerald-100 hover:text-white transition-colors cursor-pointer">
                  Contact Us
                </button>
              </li>
              <li>
                <Link to="/stump-grinding#faq" className="text-sm text-emerald-100 hover:text-white transition-colors cursor-pointer">
                  FAQ
                </Link>
              </li>
              <li>
                <Link to="/stump-grinding" className="text-sm text-emerald-100 hover:text-white transition-colors cursor-pointer">
                  Stump Grinding
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-base font-bold mb-6">Stay Updated</h4>
            <p className="text-sm text-emerald-100 mb-4">
              Subscribe to receive insider info and special offers.
            </p>
            <form id="newsletter_subscription" data-readdy-form onSubmit={handleNewsletterSubmit} className="mb-4">
              <div className="flex gap-2">
                <input
                  type="email"
                  name="email"
                  placeholder="Your email"
                  required
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  className="flex-1 px-4 py-3 bg-emerald-800 text-white text-sm rounded-lg focus:outline-none focus:ring-2 focus:ring-emerald-500 placeholder-emerald-300"
                />
                <button
                  type="submit"
                  disabled={isSubmitting}
                  className="px-5 py-3 bg-emerald-500 text-white rounded-lg hover:bg-emerald-600 transition-all cursor-pointer whitespace-nowrap disabled:opacity-50 disabled:cursor-not-allowed"
                >
                  <i className="ri-arrow-right-line"></i>
                </button>
              </div>
              {submitStatus === 'success' && (
                <p className="text-xs text-emerald-300 mt-2">Thanks for subscribing!</p>
              )}
              {submitStatus === 'error' && (
                <p className="text-xs text-red-300 mt-2">Something went wrong. Please try again.</p>
              )}
            </form>
          </div>
        </div>

        <div className="border-t border-emerald-700 pt-8">
          <div className="flex flex-col md:flex-row items-center justify-between gap-4">
            <p className="text-sm text-emerald-200">
              © 2025 Atlanta Stump Grinding Pros. All rights reserved.
            </p>
            <div className="flex items-center gap-6 text-sm text-emerald-200">
              <a href="#" className="hover:text-white transition-colors cursor-pointer">Privacy Policy</a>
              <span>|</span>
              <a href="#" className="hover:text-white transition-colors cursor-pointer">Terms of Service</a>
              <span>|</span>
              <a href="https://readdy.ai/?origin=logo" target="_blank" rel="nofollow" className="hover:text-white transition-colors cursor-pointer">Website Builder</a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
